import { isHTMLContentEmpty } from "helpers/common";
import errorMessages from "utils/validation/errorMessages";
import { emailSchema, numberRequiredSchema, phoneRequiredSchema, select2OptionalSchema, select2RequiredSchema, statusSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import { array, number, object, string } from 'yup';

const intakeFormSchema = object().shape({
    // parent: array().of(
    //     object().shape({
    //         parent_id: numberRequiredSchema,
    //         parent_absent:  string().required("Atleast select 1 parent.")
    //     })
    // ),
    parent_report: string()
        .test('is-not-empty', 'This field is required', (value) => !isHTMLContentEmpty(value))
        .required('This field is required'),
    recommendations: string()
        .test('is-not-empty', 'This field is required', (value) => !isHTMLContentEmpty(value))
        .required('This field is required')
});

export default intakeFormSchema;